/* global env */
// 获取订单支付信息
import { requestRaw, requestApi } from '../util/network'

// 用户支付
export const pay =
    (paySn, payType, data, key, uniapp = 0) =>
      requestRaw(
        env.SITE_URL + '/index.php?s=api/Memberpayment/' + payType + '/pay_sn/' + paySn + '/password/' + data.password + '/rcb_pay/' + data.rcb_pay + '/pd_pay/' + data.pd_pay + '/payment_code/' + data.payment_code + '/key/' + key + '/uniapp/' + uniapp + '/random_number/' + Math.random() + '/'
      )
// 获取支付方式列表
export const getPaymentList =
(uniapp = 0) =>
  requestApi(
    '/Memberpayment/payment_list',
    'POST',
    {
      payment_platform: uniapp ? 'app' : ''
    },
    'member'
  )

// 创建 Stripe H5 内嵌支付会话
export const createStripeSession =
(data) =>
  requestApi(
    '/Memberpayment/stripe_session',
    'POST',
    data,
    'member'
  )

// 查询 Stripe H5 支付及分期进度
export const getStripeState =
(paySn, payType) =>
  requestApi(
    '/Memberpayment/stripe_state',
    'POST',
    {
      pay_sn: paySn,
      pay_type: payType
    },
    'member'
  )
